
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/crop",
      function () {
        return require("private-next-pages/crop.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/crop"])
      });
    }
  